import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Keeps scroll position sensible across client-side navigation:
 * - navigating to a hash scrolls that section into view
 * - navigating to a new page scrolls back to the top
 *
 * Section offset is handled in CSS via `scroll-margin-top`, so the sticky
 * navbar never covers the heading.
 */
function ScrollManager() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const target = document.querySelector(hash);
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0 });
  }, [pathname, hash]);

  return null;
}

export default ScrollManager;
